import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import user from './modules/user'
import app from './modules/app'
import game from './modules/game'

Vue.use(Vuex)

/** i18n **/
let store = new Vuex.Store({
  modules: {
    user,
    app,
    game,
    i18n: vuexI18n.store
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js